import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServerResponse } from '../../interfaces/base/server.response';
import { Subject } from 'rxjs';
import { WasteCalendarService } from '../../services/reports/waste-calendar.service';
import { fadeInUpAnimation } from '../../../@fury/animations/fade-in-up.animation';
import { AuthenticationService } from '../../services/base/authentication.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LocalStorageService } from '../../services/base/local-storage.service';

@Component({
  selector: 'fury-survey',
  templateUrl: './waste-calendar.component.html',
  styleUrls: ['./waste-calendar.component.scss'],
  animations: [fadeInUpAnimation],
})
export class WasteCalendarComponent implements OnInit, OnDestroy {

  protected readonly Object = Object;

  public isLoading: boolean = null;

  public form = this.fb.group({
    postal_code: new FormControl(null, Validators.required),
    house_number: new FormControl(null, Validators.required),
    house_letter: null,
  });

  public wasteCalendarData: any = null;

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private fb: FormBuilder,
              private localStorageService: LocalStorageService,
              public authenticationService: AuthenticationService,
              public wasteCalendarService: WasteCalendarService,
  ) {
  }

  ngOnInit(): void {
    const data = this.localStorageService.get('afvalkalender');
    if (data !== null) {
      if (typeof data.postal_code !== 'undefined') {
        this.form.controls.postal_code.setValue(data.postal_code);
      }
      if (typeof data.house_number !== 'undefined') {
        this.form.controls.house_number.setValue(data.house_number);
      }
      if (typeof data.house_letter !== 'undefined') {
        this.form.controls.house_letter.setValue(data.house_letter);
      }
    }

    if (this.form.valid) {
      this.getData();
    }
  }

  getData(): void {
    this.isLoading = true;

    this.localStorageService.set('afvalkalender', {
      postal_code: this.form.controls.postal_code.value,
      house_number: this.form.controls.house_number.value,
      house_letter: this.form.controls.house_letter.value,
    });

    this.wasteCalendarService.get(this.form.value).subscribe(
      (response: ServerResponse): void => {
        if (typeof response !== 'undefined') {
          this.wasteCalendarData = response;
        }
        this.isLoading = false;
      },
      (response: ServerResponse): void => {
        if (typeof response.data !== 'undefined') {
          this.wasteCalendarData = response.data;
        }

        this.isLoading = false;
      }
    );
  }

  clearAddress(): void {
    this.form.reset();
    this.wasteCalendarData = null;
  }

  print(): void {
    window.print();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
